import React from 'react'
import Question from './Question'

function Questions({questions, setQuestions, readOnly}) {

  const AddQuestion = ()=>{
    const oId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
    s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))
    setQuestions([...questions, {_id:oId()}])
  }
  const RemoveQuestion = (id) =>{
    const q = questions.filter(question=>question._id !==id)
    setQuestions(q)
  }
  const UpdateQuestion = ({_id, img, title, answerOptions}) =>{
    const q = questions.map(question=> (question._id !==_id)?question: {_id, img, title, answerOptions} )
    setQuestions(q)
  }



  return (<>
   {!readOnly && <button type='button'  className="bg-white p-2 rounded" onClick={AddQuestion}>Add Question</button>}
    {questions.map(question=><Question key={question._id} readOnly={readOnly} question={question} RemoveQuestion={RemoveQuestion} UpdateQuestion={UpdateQuestion}  /> )}




    </>)
}

export default Questions